export default {
  links: {
    home: "ADISA",
    equipment: "Оборудование",
    info: "Документация",
    contacts: "Контакты"
  }
};
